import LinkForm from "../components/LinkForm";
import { LinkPage } from "../types/Link";
import { useLoaderData, useNavigate } from "react-router-dom";
import LocalStorageAPI from "../api/localStorageApi";
import BackButton from "../components/BackButton";

interface ParamsObject {
  params: {
    pageId: string;
  };
}

export const linkFormLoader: (
  input: ParamsObject
) => Promise<LinkPage | null> = async ({ params }) => {
  if (!params.pageId) {
    return null;
  }
  return LocalStorageAPI.getLinkPageById(params.pageId);
};

export default function LinkFormPage() {
  const navigate = useNavigate();
  const linkPage = useLoaderData() as LinkPage;

  const logForm = (linkPage: LinkPage) => {
    console.log("submitted form", linkPage);
    LocalStorageAPI.upsertLinkPage(linkPage);
    navigate("/page/" + linkPage.Stub);
  };

  return (
    <div>
      <BackButton />
      <LinkForm initialLinkPage={linkPage} onSubmit={logForm}></LinkForm>
    </div>
  );
}
